/**
 * Chip modules
 */
export * from './chip-list';
export * from './chip';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-buttons/src/chips/index.js
// module id = 1850
// module chunks = 0